var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-section-breadcrumb" },
    [
      _vm.breadcrumbs
        ? _vm._l(_vm.breadcrumbs, function (breadcrumbItem, index) {
            return _c("span", { key: index }, [
              index !== 0 ? _c("span", [_vm._v(" / ")]) : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: { href: breadcrumbItem.url, target: "_blank" },
                  on: {
                    click: function ($event) {
                      return _vm.handleBreadcrumbClick(breadcrumbItem)
                    },
                  },
                },
                [_vm._v(_vm._s(breadcrumbItem.text))]
              ),
            ])
          })
        : [
            _vm.isBusy
              ? _c("v-progress-linear", {
                  staticClass: "breadcrumb-linear-container",
                  attrs: {
                    color: "primary",
                    "buffer-value": "0",
                    stream: "",
                    reverse: "",
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }